<template>
  <a-spin :spinning="loading">
    <div class="data-panel fashion-panel">
      <div class="data-panel-header">
        <h2>时尚趋势</h2>
        <div class="extra">
          <template v-if="$service.PROJ_CODE === 'l36'">
            <label :style="{marginRight: '12px', fontWeight: 'bold'}" class="ux-filter-title">纹玉类型</label>
            <a-radio-group v-model="filter.wyType" style="margin-right: 14px;" button-style="solid">
              <a-radio-button v-for="p in options.wyTypes" :key="p.value" :value="p.id">{{p.label}}</a-radio-button>
            </a-radio-group>            
          </template>
          <a-radio-group v-model="dateType" style="margin-right: 4px;" button-style="solid">
            <a-radio-button v-for="pdate in options.dTypes" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
          </a-radio-group>        
        </div>
      </div>
      <a-empty :style="{padding: '40px 0'}" v-if="filterFashionList.length === 0" />
      <div class="data-panel-content">
        <div class="f-part">
          <div class="f-title"></div>
          <a-icon class="i-caret i-left" type="caret-left" @click="handleTurning(-1)" />
          <div class="f-content">
            <template v-for="fashion in filterFashionList">
              <div :key="fashion.fashion_id" class="f-1 item-suface">
                <span class="desc">{{fashion.fashion_id}}</span>
                <img class="item-img" :src="`${FASHION_IMG_URL}${$service.PROJ_CODE}/${fashion.fashion_id}.png`" alt="未上传外观">
                <span class="desc">{{fashion.name || '--'}}</span>
              </div>
            </template>
          </div>
          <a-icon class="i-caret i-right" type="caret-right" @click="handleTurning(1)" />
        </div>
        <div class="f-part">
          <div class="f-title">
            <div :style="{position: 'relative'}">
              销量趋势
              <a-tooltip :title="$service.PROJ_CODE==='d90'?`本页面销量数据仅考虑金块直售、赠送及其他付费解锁渠道`:$service.PROJ_CODE==='l36'?`本页面销量数据仅考虑商城直售、赠送及其他付费解锁渠道`:``">
                <a-icon :style="{fontSize: '12px', position: 'absolute', top: '0px', right: '-12px', color: '#999'}" type="question-circle" />
              </a-tooltip>
            </div>
            <div :style="{textAlign: 'center'}">
              （{{dateType === 0 ? '周' : '月'}}）
            </div>
          </div>
          <div class="f-content">
            <template v-for="(v, idx) in filterFashionList">
              <div class="f-1" :key="v.fashion_id">
                <TrendChart :dateType="dateType" :isFirst="idx===0" :xList="chartInfo.xList" :yMax="chartInfo.yMax" :cData="v.concat_sales" />
              </div>
            </template>
          </div>
        </div>
        <div class="f-part" v-if="hasOpinion">
          <div class="f-title">舆情</div>
          <div class="f-content">
            <template v-for="(v, idx) in filterFashionList">
              <div class="f-1" :key="v.fashion_id">
                <OpinionChart :isFirst="idx===0" :cData="v.public_opinion" />
              </div>
            </template>
          </div>
        </div>        
        <div class="f-part">
          <FashionDetail ref="fashionDetailRef" :dateType="dateType" :fashionList="filterOriFashionList" @updateFilterFashionList="updateFilterFashionList" />
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import TrendChart from './fashion/trend-chart.vue';
import FashionDetail from './fashion/detail.vue';
import moment from "moment";
import { FASHION_IMG_URL, WY_TYPE_OPTIONS } from '@/constants/fixed';
import _ from 'lodash';
import OpinionChart from './fashion/opinion-chart.vue';

export default {
  name: 'fashionPanel',
  components: {
    TrendChart,
    FashionDetail,
    OpinionChart
  },
  data() {
    return {
      dateType: 0,
      loading: false,
      options: {
        dTypes: [
          { id: 0, label: '周' },
          { id: 1, label: '月' },
        ],
        wyTypes: [
          { id: -1, label: '全部' },
          ...WY_TYPE_OPTIONS,
        ]
      },
      fashionList: [],
      filterFashionList: [],
      FASHION_IMG_URL,
      filter: {
        wyType: -1
      }
    }
  },
  mounted() {
    this.getFashionOverview();
  },
  watch: {
    dateType() {
      this.getFashionOverview();
    },
    "filter.wyType"() {
      this.$refs.fashionDetailRef.filterParam.currentPage = 1;
    }
  },  
  methods: {
    getFashionOverview() {
      this.loading = true;
      /*
       * count: 销量趋势数量
       * range: 0-week，1-month
       */
      this.$service.query_fixed_module(`fashion_overview`, {
        count: 10,
        range: this.dateType
      }).then(res => {
        this.loading = false;
        if (res.data) {
          this.fashionList = (res.data || []).filter(r => r.name);
        }
      }).catch(() => {
        this.loading = false;
      });

    },
    updateFilterFashionList(list) {
      this.filterFashionList = list;
    },
    handleTurning(idx) {
      const maxPage = _.ceil(this.filterOriFashionList.length / 5);
      if (this.$refs.fashionDetailRef.filterParam.currentPage === 1 && idx === -1) {
        this.$message.warning('已经是第一页')
      } else if (this.$refs.fashionDetailRef.filterParam.currentPage === maxPage && idx === 1) {
        this.$message.warning('已经是最后一页')
      } else {
        this.$refs.fashionDetailRef.filterParam.currentPage += idx;
      }
    }
  },
  computed: {
    chartInfo() {
      const xSet = new Set();
      let yMax = 0;
      this.filterFashionList.forEach(f => {
        (f.concat_sales || []).forEach(sale => {
          xSet.add(sale.time);
          if (yMax < sale.data) {
            yMax = sale.data;
          }
        })
      });
      return {
        xList: Array.from(xSet).sort((prev, next) => moment(prev).unix() - moment(next).unix()),
        yMax
      }
    },
    hasOpinion() {
      const hasOpinionList = this.fashionList.filter(opi => !_.isEmpty(opi.public_opinion));
      return hasOpinionList.length > 0;
    },
    filterOriFashionList() {
      // FIXME: 后续再有新游戏，考虑通用方案
      return this.fashionList.filter(fashion => {
        const f_wyType = this.filter.wyType === -1 ? true : fashion.last_money_type === this.filter.wyType;
        return f_wyType;
      });
    }
  }
}
</script>

<style lang="less">
.fashion-panel {
  .i-caret {
    font-size: 24px;
    padding: 0 4px;
    cursor: pointer;
    opacity: 0.75;
    color: #187fff;
    position: absolute;
    &.i-left {
      left: 36px;
    }
    &.i-right {
      right: -26px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .f-part {
    padding: 8px 0;
    display: flex;
    align-items: center;
    position: relative;
    .f-title {
      width: 64px;
      padding-right: 8px;
      align-items: center;
      font-weight: bold;
    }
    .f-content {
      display: flex;
      align-items: center;
      flex: 1;
    }
    .f-1 {
      width: 20%;
      padding: 2px;
    }
    .item-suface {
      display: flex;
      flex-direction: column;
      align-items: center;
      .desc {
        padding: 2px;
        font-weight: bold;
      }
      .item-img {
        width: 100%;
        height: 360px;
        background: #ddd;
        object-fit: cover;
      }
    }
  }
}
</style>